import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
//import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/styles.css';
import VueRouter from 'vue-router'




Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(VueRouter)


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


